import { AlertCircleIcon, PlusIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

import { PermissionsGate } from '@/modules/auth/components/permissions/PermissionsGate';
import { permissions } from '@/modules/auth/permissions';
import { Alert, AlertDescription } from '@/modules/ui/components/alert/Alert';
import { Button } from '@/modules/ui/components/button/Button';
import Container from '@/modules/ui/components/container/Container';
import Loader from '@/modules/ui/components/loader/Loader';
import { PageHeader } from '@/modules/ui/components/page-header/PageHeader';
import { UserList } from '@/modules/users/components/UserCardList';
import { useUsersQuery } from '@/modules/users/queries/useUsersQuery';

const Users = () => {
  const usersQuery = useUsersQuery();

  return (
    <Container>
      <PageHeader
        title="Users"
        action={
          <PermissionsGate permissions={[permissions.Users.Create]}>
            <Button variant="primary" asChild>
              <Link to="/users/add">
                <PlusIcon />
                Add User
              </Link>
            </Button>
          </PermissionsGate>
        }
      />

      {usersQuery.isLoading && <Loader />}

      {usersQuery.isError && (
        <Alert variant="destructive">
          <AlertCircleIcon />
          <AlertDescription>Failed to load users</AlertDescription>
        </Alert>
      )}

      {usersQuery.data && <UserList users={usersQuery.data} />}
    </Container>
  );
};

export default Users;
